import axios from 'axios';
import { UnsavedMedia } from '../../structures/models/media/media';

import {
  CLOUDINARY_CLOUD_NAME,
} from '../constants';

// eslint-disable-next-line import/prefer-default-export,max-len
export const upload = async (file: string, index: number, preset: string | undefined): Promise<UnsavedMedia > => {
  const response = await axios.post(`https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD_NAME}/upload`, {
    file,
    upload_preset: preset,
  }, { headers: { Accept: 'application/json' } });

  return {
    file_url: response.data.secure_url,
    public_id: response.data.public_id,
    file_name: response.data.original_filename,
    file_type: response.data.resource_type,
    sort_id: index,
    size: response.data.bytes,
  };
};
